module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="modal-content">\n    <div class="center-absolute">\n        <div class="loader"></div>\n    </div>\n</div>\n';

}
return __p
}